import PropTypes from "prop-types";
import "./sidenav.scss";
import { MENU_ITEMS } from "./utils";
import NavItem from "./NavItem";

const SideNav = ({ isOpen }) => {
  const collapsed = !isOpen;

  return (
    <aside className={["sidenav", isOpen ? "open" : ""].join(" ")}>
      {/* Main menu */}
      <nav className="sidenav__menu" aria-label="Primary">
        {MENU_ITEMS.map(({ key, to, label, icon: Icon }) => (
          <NavItem
            key={key}
            to={to}
            label={label}
            Icon={Icon}
            collapsed={collapsed}
          />
        ))}
      </nav>
    </aside>
  );
};

SideNav.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default SideNav;
